import React, { Component } from 'react'
import ServicesSidebar from './ServicesSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class LibraryUserAwareness extends Component {
    render() {
        return (
            <div>
                {/* Header */}
                <Header />

                {/* Banner */}
                <Banner title="Services" image="banner/library-2.jpg" />

                {/* Content */}
                <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-9 content-area order-lg-2">
                                <div className="ttm-service-single-content-area">
                                    <div className="section-title with-desc text-left clearfix">
                                        <div className="title-header" style={{ borderTopColor: "red" }}>
                                            <h4 className="title">User Awareness Programmes</h4>
                                        </div>
                                    </div>
                                    <div className="ttm-service-description">
                                        <div className="row justify">
                                            <div className="col-md-5">
                                                <div className="ttm_single_image-wrapper">
                                                    <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/services/UserAwareness.jpg"} alt="single-img-eighteen" />
                                                </div>
                                            </div>
                                            <div className="col-md-7">
                                                <h6 className="res-767-mt-20"></h6>
                                                <p>The Library takes an active part in the orientation program for the benefit of new students at the beginning of the academic year. They are taken around the library to familiarize themselves with various resources and services available in the Library. Training sessions are also organized whenever a new product or service is introduced.<br/><br/>Any user desiring to know more about Library resources and services or to learn how to use a particular resource like OPAC, e-journals, databases, etc. should contact any Library Staff Members or at Information Desk.</p>
                                            </div>
                                            <div className="col-md-12 paddingtop-1">
                                                <p>Library Awareness program service as part of our user awareness program, the Library regularly organizes Orientation/Training programs on library resources and services. Members can meet the Librarian for discussions if any.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 widget-area">
                                <ServicesSidebar />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <Footer />
            </div>
        )
    }
}
